function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 251, 249)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'no-frame': 'url("//editafieldsart.com/cdn/shop/files/frame-no-frame_120x.png?v=9262755138501559469")','black': 'url("//editafieldsart.com/cdn/shop/files/frame-black_120x.png?v=15658944470341958887")','white': 'url("//editafieldsart.com/cdn/shop/files/frame-white_120x.png?v=7786277299090902549")','natural': 'url("//editafieldsart.com/cdn/shop/files/frame-natural_120x.png?v=5935")','oak': 'url("//editafieldsart.com/cdn/shop/files/frame-oak_120x.png?v=15221064674723965931")','white-wood': 'url("//editafieldsart.com/cdn/shop/files/white-wood_120x.png?v=1071934998378484395")','black-wood': 'url("//editafieldsart.com/cdn/shop/files/black-wood_120x.png?v=8548445804108625164")','oak-nature': 'url("//editafieldsart.com/cdn/shop/files/oak-nature_120x.png?v=8181948353159592808")','oak-dark': 'url("//editafieldsart.com/cdn/shop/files/oak-dark_120x.png?v=7170180662176670769")','bez-ramu': 'url("//editafieldsart.com/cdn/shop/files/frame-no-frame_120x.png?v=9262755138501559469")','dub': 'url("//editafieldsart.com/cdn/shop/files/frame-oak_120x.png?v=15221064674723965931")','bily-ram': 'url("//editafieldsart.com/cdn/shop/files/frame-white_120x.png?v=7786277299090902549")','cerny-ram': 'url("//editafieldsart.com/cdn/shop/files/frame-black_120x.png?v=15658944470341958887")','bile-drevo': 'url("//editafieldsart.com/cdn/shop/files/white-wood_120x.png?v=1071934998378484395")','cerne-drevo': 'url("//editafieldsart.com/cdn/shop/files/black-wood_120x.png?v=8548445804108625164")','svetly-dub': 'url("//editafieldsart.com/cdn/shop/files/oak-nature_120x.png?v=8181948353159592808")','tmavy-dub': 'url("//editafieldsart.com/cdn/shop/files/oak-dark_120x.png?v=7170180662176670769")',};

    this.triggers = ['frame','rám',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
